<template>
  <!-- NOTE (TEMPLATE) to show the proposal reviewers -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/reviewers'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <!-- NOTE (b-addReviewer) to add new reviewer -->
      <b-button variant="success" class="mb-3" @click="addReviewer()">
        <strong>افزودن داور جدید +</strong>
      </b-button>
      <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 0 1px 15px">
        <v-col>
          <h4 style="margin-top: 9px">داوران</h4>
        </v-col>
        <v-col>
          <v-btn
            class="bc-primary text-white btn-radius float-end"
            width="200"
            height="45"
            elevation="0"
            :disabled="isBusy || !items.length"
            @click="$refs.table1.$el.click()"
          >
            <span class="fs-small">
              خروجی اکسل

              <v-icon>$Excel</v-icon></span
            >
          </v-btn>
          <vue-excel-xlsx
            v-show="false"
            ref="table1"
            :data="items"
            :columns="excelFields"
            :filename="'لیست داوران'"
            :sheetname="currentDate"
          >
            دریافت اکسل
          </vue-excel-xlsx>
        </v-col>
      </v-row>
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-reviewerList) to show the reviewers list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        empty-text="هنوز رکوردی ثبت نشده است"
        striped
        :busy="isBusy"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>

        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div
            style="
              text-align: center;
              vertical-align: middle;
              width: 150px;
              margin: auto;
            "
          >
            <!-- NOTE <a> to go to the reviewer profile -->
            <a
              class="btn text-light btn-primary mx-1"
              :href="'/admin/reviewer/' + data.item.id"
              target="_blank"
              style="width: 100%"
              >مشاهده پروفایل</a
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import moment from "moment-jalaali";

export default {
  components: {},
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "natCode", label: "شماره ملی" },
        { key: "lastDegree", label: "آخرین مدرک تحصیلی" },
        { key: "university", label: "دانشگاه" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "name", label: "نام و نام خانوادگی" },
        { field: "natCode", label: "شماره ملی" },
        { field: "lastDegree", label: "آخرین مدرک تحصیلی" },
        { field: "university", label: "دانشگاه" },
        { field: "status", label: "وضعیت" },
      ],
      items: [],
      filter: "",
      filterOn: [],
      isBusy: true,
    };
  },
  watch: {
    $route: function () {
      this.onMounted();
    },
  },
  methods: {
    addReviewer() {
      // NOTE (m-addReviewer) to go to the add reviewer page
      router.push("/admin/addReviewer");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reviewers/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
          this.isBusy = false;
        });
    },
  },
  mounted() {
    if (this.$router.currentRoute.path == "/admin/reviewers") {
      this.onMounted();
    }
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
